import {
    type SearchIntent,
    searchIntentSchema,
} from "./search-intent.contract.ts";

export function normalizeSearchIntentQuery(query: string): string {
    return query.trim().replace(/\s+/g, " ");
}

export function createEmptySearchIntent(): SearchIntent {
    return searchIntentSchema.parse({
        filters: {
            breedSlugs: [],
            dogName: null,
            breedType: null,
            providerName: null,
            providerType: null,
            sex: null,
            priceMin: null,
            priceMax: null,
            ageMonthsMin: null,
            ageMonthsMax: null,
            size: [],
            coatType: [],
            sheddingLevel: [],
            hypoallergenic: null,
            friendlinessChildren: null,
            friendlinessDogs: null,
            friendlinessCats: null,
            energyLevel: null,
            trainability: null,
            healthIssuesRisk: null,
            sortBy: null,
            locationQuery: null,
            maxDistanceMiles: null,
            hardRadius: null,
        },
        semanticQuery: null,
        noise: [],
    });
}
